import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface AddressInputUniDriver extends BaseUniDriver {
  getInputValue: () => Promise<string>;
  enterText: (value: string) => Promise<void>;
  clickClear: () => Promise<void>;
  isDisabled: () => Promise<boolean>;
  isLoading: () => Promise<boolean>;
  clickAtOption: (index: number) => Promise<void>;
  clickAtOptionWithValue: (value: string) => Promise<void>;
  clickInput: () => Promise<void>;
  getAmountOfItems: () => Promise<number>;
  getItemMainLabelAt: (index: number) => Promise<string>;
  getItemSecondaryLabelAt: (index: number) => Promise<string>;
  pressEnter: () => Promise<void>;
  isFocused: () => Promise<boolean>;
}
